import { Button } from '@/components/ui/button';
import { ShoppingCart, Heart, Zap } from 'lucide-react';

interface ProductActionsProps {
  onAddToCart: () => void;
  onBuyNow?: (type: 'razorpay' | 'shiprocket') => void;
  stock: number;
  compact?: boolean;
  showBuyNow?: boolean;
}

export const ProductActions = ({ 
  onAddToCart, 
  onBuyNow,
  stock, 
  compact = false,
  showBuyNow = true 
}: ProductActionsProps) => {
  if (compact) {
    return (
      <Button 
        onClick={onAddToCart}
        disabled={stock === 0}
        className="whitespace-nowrap px-4 py-2 h-auto text-sm"
        size="sm"
      >
        {stock === 0 ? 'Out of Stock' : 'Add to Cart'}
      </Button>
    );
  }
  
  return (
    <div className="space-y-3">
      {/* Add to Cart row - hidden on mobile, shown on tablet/desktop */}
      <div className="hidden md:flex gap-3">
        <Button 
          onClick={onAddToCart} 
          disabled={stock <= 0}
          className="flex-1"
        >
          <ShoppingCart className="mr-2 h-4 w-4" />
          Add to Cart
        </Button>
        <Button variant="outline" size="icon">
          <Heart className="h-4 w-4" />
        </Button>
      </div>
      
      {showBuyNow && onBuyNow && stock > 0 && (
        <div className="space-y-2">
          <p className="text-xs text-muted-foreground text-center">Express Checkout</p>
          <Button
            onClick={() => onBuyNow('razorpay')}
            className="w-full bg-[#072654] hover:bg-[#0a3a7d] text-white"
          >
            <Zap className="mr-1.5 h-4 w-4" />
            Razorpay Express
          </Button>
        </div>
      )}
    </div>
  );
};
